import { render, staticRenderFns } from "./diff.vue?vue&type=template&id=70162a2a&scoped=true"
import script from "./diff.vue?vue&type=script&lang=js"
export * from "./diff.vue?vue&type=script&lang=js"
import style0 from "./diff.vue?vue&type=style&index=0&id=70162a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70162a2a",
  null
  
)

export default component.exports